export default __webpack_public_path__ + "static/media/a47a87bd6e7ede16ab9bf8d263c1efd9.9dbb6777.png";